import React from 'react';
import PropTypes from 'prop-types';
import gettext from '@eb/gettext';
import take from 'lodash/take';
import map from 'lodash/map';
import isEmpty from 'lodash/isEmpty';
import { EVENT_CARD_SHARE_OPTIONS_PROPTYPE } from '@eb/eds-event-card';

import { SEARCH_SECTION, LIST_CARD_TEMPLATE } from '../../../../constants';

import CardBucket from '../../../../components/cardBucket/CardBucket';

export const EventSuggestions = (props) => {
    const {
        eventSuggestions,
        shareOptions,
        onSaveEvent,
        isAuthenticated,
        allEventsUrl,
        featureFlags,
        userCollections,
        onAddOrRemoveEventToCollection,
        onCreateCollection,
        trackGAEventOnPageUnload,
        suggestionsLoading,
        trackGAEvent,
    } = props;

    if (isEmpty(eventSuggestions) && !suggestionsLoading) {
        return null;
    }

    const trackSeeMore = (_, linkUrl) => {
        props.trackGAEvent({
            action: 'ViewMore',
            label: linkUrl,
        });
    };

    let content = map(eventSuggestions, (event = {}) => ({
        ...event,
        section: SEARCH_SECTION,
        excludeExtraContent: true,
    }));

    content = take(content, 5);

    return (
        <div className="pivot-section eds-l-pad-bot-4">
            <CardBucket
                trackSeeMore={trackSeeMore}
                isLoading={suggestionsLoading}
                content={content}
                template={LIST_CARD_TEMPLATE}
                shareOptions={shareOptions}
                name={gettext('Popular events')}
                linkUrl={allEventsUrl}
                onSaveEvent={onSaveEvent}
                isAuthenticated={isAuthenticated}
                featureFlags={featureFlags}
                bucketKey="near_you"
                userCollections={userCollections}
                trackGAEventOnPageUnload={trackGAEventOnPageUnload}
                trackGAEvent={trackGAEvent}
                onAddOrRemoveEventToCollection={onAddOrRemoveEventToCollection}
                onCreateCollection={onCreateCollection}
            />
        </div>
    );
};

EventSuggestions.propTypes = {
    shareOptions: EVENT_CARD_SHARE_OPTIONS_PROPTYPE.isRequired,
    onSaveEvent: PropTypes.func,
    userCollections: PropTypes.arrayOf(PropTypes.object),
    onAddOrRemoveEventToCollection: PropTypes.func,
    onCreateCollection: PropTypes.func,
    isAuthenticated: PropTypes.bool,
    eventSuggestions: PropTypes.arrayOf(PropTypes.object),
    allEventsUrl: PropTypes.string,
    trackGAEventOnPageUnload: PropTypes.func,
    trackGAEvent: PropTypes.func,
    trackSeeMore: PropTypes.func,
};
